import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";

import { logoutUser } from "../slices/auth/login/thunk";

interface AuthProtectedProps {
  children: React.ReactNode;
  roles?: string[];
  menuCategory?: string;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({
  children,
  roles,
  menuCategory,
}) => {
  const dispatch: any = useDispatch();
  const location = useLocation();
  const { userProfile, loading, token } = useProfile();

  const userRole = sessionStorage.getItem("userRole") || "";
  const currentCompany = sessionStorage.getItem("currentCompany");

  const getMenus = (): string[] => {
    const menuString = sessionStorage.getItem("menu");
    if (menuString) {
      try {
        return JSON.parse(menuString);
      } catch {
        return [];
      }
    }
    return [];
  };

  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  if (!userProfile && loading && !token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles && roles.length > 0) {
    if (!roles.includes(userRole)) {
      const redirectPath =
        userRole === "superadmin" ? "/superadmin/dashboard" : "/dashboard";
      return <Navigate to={redirectPath} replace />;
    }
  }

  const isSuperadminMode = userRole === "superadmin" && !currentCompany;

  if (menuCategory && !isSuperadminMode) {
    const allowedMenus = getMenus();
    const hasMenuAccess =
      allowedMenus.length === 0 || allowedMenus.includes(menuCategory);

    if (!hasMenuAccess) {
      const redirectPath =
        userRole === "superadmin" ? "/superadmin/dashboard" : "/dashboard";
      return <Navigate to={redirectPath} replace />;
    }
  }

  return <>{children}</>;
};

export default AuthProtected;
